module.exports = __webpack_public_path__ + "img/dcu30-3.12286eb1.png";